<template>
  <v-card horizontal class="mb-4">
    <v-card-row
      v-if="value.picture && value.picture.normal"
      :img="value.picture.normal"
      height="200px">
    </v-card-row>
    <v-card-column>
      <v-card-row>
        <v-card-text>
          <div>
            <strong>{{ value.subtitle || value.title }}</strong>
            <template v-if="value.price">
              -
              <price :value="value.price"></price>
            </template>
          </div>
          <p>{{ value.description.short }}</p>
        </v-card-text>
      </v-card-row>
      <v-card-row actions>
        <v-btn flat tag="a" :href="url" target="_blank">
          {{ $t('messenger.previews.offer.action') }}
        </v-btn>
      </v-card-row>
    </v-card-column>
  </v-card>
</template>

<script>
  import Service from '@/api/service'
  import { Price } from '@/components/formatters'
  export default {
    components: {
      Price
    },
    props: {
      value: {
        type: Object,
        required: true
      }
    },
    computed: {
      url () {
        if (!this.value.url) { return null }
        return Service.isOfferType(this.value.service_type)
          ? this.value.url
          : this.value.url.replace('/o/', '/p/')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/messenger/previews/Offer.vue